import { render, staticRenderFns } from "./LeaveCommentWasAdded.vue?vue&type=template&id=fefd0088"
import script from "./LeaveCommentWasAdded.vue?vue&type=script&lang=js"
export * from "./LeaveCommentWasAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports